var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"activity"}},[(!_vm.showAddGoods)?_c('AllActivity',{on:{"handleEditActivity":_vm.handleEditActivity}}):_c('AddActivity',{attrs:{"activityInfo":_vm.activityInfo,"showAddGoods":_vm.showAddGoods},on:{"handleSuccess":_vm.handleSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }